const error = require('debug')('svtse:middleware:error');
const catcher = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (err) {
    error('Caught an exception!', err);
    throw err;
  }
};

export default catcher;



/** WEBPACK FOOTER **
 ** ./app/middleware/catcher.js
 **/